import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { RequestVincularCobrancasAoProcessoDTO } from "types/request/RequestVincularCobrancasAoProcessoDTO";

export const usePostVincularCobrancasAoProcesso = () => {
  const onSuccess = () => {
    queryClient.invalidateQueries(["selecionar-cobrancas-processo-judicial"]);
    queryClient.invalidateQueries(["cobrancas-vinculadas-ao-processo"]);
    queryClient.invalidateQueries(["processos-judiciais-historicos"]);
  };

  return usePost<RequestVincularCobrancasAoProcessoDTO>({
    url: api.processosJudiciais.postVincularCobrancas,
    onSuccess,
    onError: () => toast.error("Erro ao vincular cobranças ao processo."),
  });
};
